// extracted by mini-css-extract-plugin
module.exports = {"table":"Table_table_17-80","actions":"Table_actions_9zo02"};